import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

interface OverlayWrapperProps {
    isFadingOut: boolean;
}

export const OverlayWrapper = withConfig(theme => styled('div', { label: 'OverlayWrapper' })<OverlayWrapperProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${theme.star.idMission.bgColorSecondary};
    z-index: 10011;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 48px;
    opacity: ${({ isFadingOut }): number => (isFadingOut ? 0 : 1)};
    transition: opacity 0.3s ease-out;
`);

export const OverlayLogo = withConfig(theme => styled('div', { label: 'OverlayLogo' })`
    width: 300px;
    padding: 24px 16px;
    background: ${theme.star.idMission.bgColorTertiary};
    display: flex;
    justify-content: center;

    @media ${theme.star.mediaQuery.tablet} {
        width: 400px;
    }

    svg {
        width: 100%;
        height: 100%;
    }
`);

export const OverlayImage = withConfig(theme => styled('img', { label: 'OverlayImage' })`
    border: 2px solid ${theme.star.idMission.borderPrimary};
    border-radius: 8px;
    box-shadow: 0 4px 12px ${theme.star.idMission.boxShadow};
    width: 300px;
    aspect-ratio: 1 / 1;

    @media ${theme.star.mediaQuery.tablet} {
        width: 400px;
    }
`);
